import { Dispatch, ReactElement } from 'react'
import { AlertColor } from '@mui/material/Alert'
import { createSelector } from 'reselect'
import { AnyAction } from 'redux'
import { AppDispatch, RootStore } from '../store'

export interface SnackBar {
  message: string | ReactElement
  severity: AlertColor
}

export interface snackbarState {
  snackBar: SnackBar | null
}

export const initialState: snackbarState = {
  snackBar: null,
}

// Action Types
const SET_SNACKBAR_MESSAGE = 'SET_SNACKBAR_MESSAGE'
const CLEAR_SNACKBAR_MESSAGE = 'CLEAR_SNACKBAR_MESSAGE'

// Action Creators
interface SetSnackbarMessageAction {
  type: typeof SET_SNACKBAR_MESSAGE
  payload: SnackBar
}

interface ClearSnackbarMessageAction {
  type: typeof CLEAR_SNACKBAR_MESSAGE
  payload: null
}

type snackBarDispatchtypes = SetSnackbarMessageAction | ClearSnackbarMessageAction

// Actions
export const showSuccessMessage = (message: string | ReactElement): SetSnackbarMessageAction => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: { message, severity: 'success' },
})

export const showWarningMessage = (message: string | ReactElement): SetSnackbarMessageAction => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: { message, severity: 'warning' },
})

export const showErrorMessage = (message: string | ReactElement): SetSnackbarMessageAction => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: { message, severity: 'error' },
})

export const showInfoMessage = (message: string | ReactElement): SetSnackbarMessageAction => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: { message, severity: 'info' },
})

export const clearSnackbarMessage = (): ClearSnackbarMessageAction => ({
  type: CLEAR_SNACKBAR_MESSAGE,
  payload: null,
})

// Selectors
export const snackBarMessage = createSelector(
  (state: RootStore) => state.snackBar,
  (snackBar: snackbarState) => snackBar.snackBar
)

// Reducer
export const snackBarReducer = (
  state: snackbarState = initialState,
  action: snackBarDispatchtypes
): snackbarState => {
  switch (action.type) {
    case SET_SNACKBAR_MESSAGE:
      return { ...state, snackBar: action.payload }
    case CLEAR_SNACKBAR_MESSAGE:
      return { ...state, snackBar: null }
    default:
      return state
  }
}
